import { Component } from '@angular/core';

interface NewsArticle {
  title: string;
  author?: string;
  publication: string;
  issue?: string;
  url: string;
  lastAccessed: string;
  bluf: string;
  imageUrl?: string;
  imageAlt?: string;
}

@Component({
  selector: 'app-newsquantum',
  templateUrl: './newsquantum.component.html',
  styleUrls: ['./newsquantum.component.css'],
})
export class NewsquantumComponent {
  articles: NewsArticle[] = [
    {
      title:
        'Four Things Every Business Leader Should Know About Quantum Computing, According To An MIT Quantum Engineer',
      author: 'Matt Swayne',
      publication: 'Quantum Insider',
      issue: '10 DEC 2025',
      url: 'https://thequantuminsider.com/four-things-every-business-leader-should-know-about-quantum-computing-according-to-an-mit-quantum-engineer/',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://thequantuminsider.com/wp-content/uploads/2025/12/kbufvkbfioe.jpg',
      imageAlt:
        'Quantum Insider article header image illustrating quantum computing',
      bluf:
        'Encrypted data stolen today can be stored and decrypted later once quantum machines mature, creating a long-term exposure window for sensitive corporate data.\n\nFor private companies, the takeaway is that post-quantum cryptography is becoming part of mainstream security planning and can be phased in as a software-driven modernization effort well before quantum hardware is operational.',
    },
    {
      title:
        'US government outlines plans for "unhackable" national quantum internet',
      author: 'Michael Irving',
      publication: 'New Atlas',
      issue: '26 JUL 2020',
      url: 'https://newatlas.com/telecommunications/us-government-blueprint-national-quantum-internet/',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://assets.newatlas.com/dims4/default/0cbeacc/2147483647/strip/true/crop/2000x1333+0+0/resize/800x533!/format/webp/quality/90/?url=https%3A%2F%2Fnewatlas-brightspot.s3.amazonaws.com%2F99%2F54%2Facefaa2f49fd91259fb9c114a324%2Fdepositphotos-38217683-l-2015.jpg',
      imageAlt:
        'Illustration photo used by New Atlas for quantum internet article',
      bluf:
        'The U.S. Department of Energy outlined a blueprint for a national “quantum internet,” identifying research priorities and milestones toward secure quantum networking.\n\nThe article explains how entanglement-based communication could improve data security and how government labs and universities are already building early quantum network testbeds.',
    },
    {
      title: 'Inventions in quantum technologies surge five-fold in last decade',
      publication: 'European Patent Office (EPO)',
      issue: '17 DEC 2025',
      url: 'https://www.epo.org/en/news-events/news/inventions-quantum-technologies-surge-five-fold-last-decade',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://www.epo.org/sites/default/files/styles/ratio_16_9/public/2025-11/EPO-OECD%20Study_Quantum_1920x1080.jpg?h=920929c4&itok=zS8ldANu',
      imageAlt:
        'EPO-OECD study image related to growth in quantum technology inventions',
      bluf:
        'A joint EPO–OECD study reports that international patent families in quantum technologies have grown five-fold since 2015, spanning quantum communication, computing, and sensing.\n\nThe article highlights uneven growth by domain, major regional players, and the need to strengthen investment, skills, collaboration, and supply chains as the sector moves toward commercialization.',
    },
    {
      title: 'Toshiba Warns of Quantum Threats to Telecom Networks',
      author: 'Stella Nolan',
      publication: 'Telecom Magazine',
      issue: '09 DEC 2025',
      url: 'https://telcomagazine.com/news/toshiba-warns-quantum-threats-to-telecom-networks',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://assets.bizclikmedia.net/900/8155f5d39a3fb4d1e8800eb613eec589:eca8194b345b42e1889e9abc069281e0/1752481403086-e-1766620800-v-beta-t-eo1ztfe0yckhebo6hytmy1qeqxa4lyoulrwnhrh4g2u',
      imageAlt:
        'Toshiba Europe quantum technology imagery used in telecom security article',
      bluf:
        'Toshiba warns that telecom networks face urgent quantum-era risks, including “store-now, decrypt-later” attacks against long-lived encrypted traffic.\n\nThe article argues that operators should adopt defence-in-depth now by combining Quantum Key Distribution (QKD) with post-quantum cryptography (PQC), enabling crypto-agility, protecting customer trust, and avoiding rushed, high-risk migrations as Q-Day approaches.',
    },
    {
      title: 'European Quantum Communication Infrastructure – EuroQCI',
      publication: 'European Commission – Digital Strategy',
      issue: '08 JUL 2025',
      url: 'https://digital-strategy.ec.europa.eu/en/policies/european-quantum-communication-infrastructure-euroqci',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://digital-strategy.ec.europa.eu/themes/contrib/oe_theme/dist/ec/images/logo/positive/logo-ec--en.svg',
      imageAlt:
        'European Commission logo used on EuroQCI policy page',
      bluf:
        'The EuroQCI initiative aims to build a pan-European quantum communication infrastructure combining terrestrial fibre networks and satellite-based systems to secure sensitive data and critical infrastructure.\n\nLed by the European Commission with all EU Member States and ESA, EuroQCI integrates quantum key distribution into existing networks, reinforcing Europe’s long-term cybersecurity and digital sovereignty.',
    },
    {
      title:
        'Breakthrough 3D wiring architecture enables 10,000-qubit quantum processors',
      author: 'Tristan Greene',
      publication: 'Live Science',
      issue: '11 DEC 2025',
      url: 'https://www.livescience.com/technology/computing/breakthrough-3d-wiring-architecture-enables-10-000-qubit-quantum-processors',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://cdn.mos.cms.futurecdn.net/Q2LFmwktADn3DpFLeHaT3d-650-80.png.webp',
      imageAlt:
        'Illustration of quantum processor wiring used in Live Science article',
      bluf:
        'Researchers at QuantWare demonstrated a vertical 3D wiring architecture that could allow a single quantum processor to support up to 10,000 qubits.\n\nBy overcoming wiring bottlenecks through chiplet-based integration, the approach could accelerate the development of economically relevant, large-scale quantum computing systems.',
    },
    {
      title: 'Tiny optical modulator could enable giant future quantum computers',
      publication: 'Phys.org',
      issue: '11 DEC 2025',
      url: 'https://phys.org/news/2025-12-tiny-optical-modulator-enable-giant.html',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://scx1.b-cdn.net/csz/news/800a/2025/tiny-new-device-could.jpg',
      imageAlt:
        'Ultra-compact optical phase modulator for quantum computing',
      bluf:
        'Researchers at the University of Colorado Boulder developed ultra-compact optical phase modulators that precisely control laser frequencies while using far less power than existing devices.\n\nBuilt using scalable CMOS fabrication, the technology could enable practical control of thousands or even millions of qubits, removing a key bottleneck in scaling atom-based quantum computers.',
    },
    {
      title:
        'New digital state of matter could help build stable quantum computers',
      author: 'Paul Arnold',
      publication: 'Phys.org',
      issue: '01 DEC 2025',
      url: 'https://phys.org/news/2025-12-digital-state-stable-quantum.html',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://scx1.b-cdn.net/csz/news/800a/2025/scientists-create-new-2.jpg',
      imageAlt:
        'Visualization of a digitally engineered nonequilibrium quantum state',
      bluf:
        'Scientists used a superconducting quantum processor to create and study a rare, highly stable “digital” state of matter with protected corner states.\n\nThe work shows how quantum computers can act as reliable simulators for discovering error-resistant phases of matter, pointing toward more stable and trustworthy quantum hardware in the future.',
    },
    {
      title:
        'Ethereum scientist warns 20% chance quantum computers could break crypto',
      author: 'Anand Sinha',
      publication: 'TheStreet',
      issue: '28 AUG 2025',
      url: 'https://www.thestreet.com/crypto/innovation/ethereum-scientist-warns-20-chance-quantum-computers-could-break-crypto',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://www.thestreet.com/.image/c_limit%2Ccs_srgb%2Cq_auto:good%2Cw_700/MjE3Mzc0NzA1NjI2MTI5NTQ2/gettyimages-1238607125.webp',
      imageAlt:
        'Illustration associated with quantum computing and cryptocurrency risk',
      bluf:
        'Ethereum co-founder Vitalik Buterin warned that there is an estimated 20% chance quantum computers could break modern cryptography before the end of 2030.\n\nThe article highlights growing concern over “store-now, decrypt-later” risks for blockchain systems and underscores the need for post-quantum cryptographic transitions in crypto and broader digital infrastructure.',
    },
    {
      title:
        '‘It’s a Mess’: A Brain-Bending Trip to Quantum Theory’s 100th Birthday Party',
      author: 'Charlie Wood',
      publication: 'Quanta Magazine',
      issue: '08 AUG 2025',
      url: 'https://www.quantamagazine.org/its-a-mess-a-brain-bending-trip-to-quantum-theorys-100th-birthday-party-20250808/',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://www.quantamagazine.org/wp-content/uploads/2050/07/100-Years-of-Quantum-Mechanics-cr-Senor-Salme-Lede-2048x1152.webp',
      imageAlt:
        'Conference gathering marking 100 years of quantum mechanics (Quanta Magazine)',
      bluf:
        'Quanta Magazine reports from the 100th anniversary conference of quantum mechanics, highlighting that while the theory works spectacularly, physicists still debate what it “means” - especially around measurement and reality.\n\nThe article offers a readable snapshot of modern disagreements over interpretations (Copenhagen, many-worlds, QBism, and others) and why foundational questions continue to matter even as quantum technologies advance.',
    },
    {
      title:
        'UTahQuantum: Bridging the Gap Between Theory and Real-World Quantum Technology',
      author: 'Mark Tullis',
      publication: 'TechBuzz News',
      issue: '26 NOV 2025',
      url: 'https://www.techbuzznews.com/utahquantum-bridging-the-gap/',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://www.techbuzznews.com/content/images/2025/11/Screenshot-2025-11-25-at-12.42.21---PM-1.png',
      imageAlt:
        'UTahQuantum article image from TechBuzz News',
      bluf:
        'The article profiles UTahQuantum, a Salt Lake City startup positioning itself as a “Quantum Systems Integrator” to bridge academia, enterprise needs, and government priorities.\n\nIt emphasizes post-quantum encryption readiness, national-security-focused risk framing, and near-term pilots and assessments aimed at helping organizations prepare for quantum-era disruption.',
    },
    {
      title: 'Scientists build a quantum computer that can repair itself using recycled atoms',
      author: 'Paul Arnold',
      publication: 'Phys.org',
      issue: '18 DEC 2025',
      url: 'https://phys.org/news/2025-12-scientists-quantum-recycled-atoms.html',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://scx1.b-cdn.net/csz/news/800a/2025/scientists-build-a-qua.jpg',
      imageAlt:
        'Neutral-atom quantum computer using optical tweezers and recycled atoms',
      bluf:
        'By overcoming the limited lifespan of individual atoms, [scientists] have moved a step closer to a quantum computer that can run indefinitely.',
    },
    {
      title: 'Scientists prove “impossible” Earth-to-space quantum link is feasible',
      publication: 'ScienceDaily',
      issue: '17 DEC 2025',
      url: 'https://www.sciencedaily.com/releases/2025/12/251217082515.htm',
      lastAccessed: '22 DEC 2025',
      imageUrl:
        'https://www.sciencedaily.com/images/1920/global-communication-network-around-planet-earth.webp',
      imageAlt:
        'Global communications network around Earth (ScienceDaily image)',
      bluf:
        'Researchers have shown that quantum signals can be sent from Earth up to satellites, not just down from space as previously believed. This breakthrough could make global quantum networks far more powerful, affordable, and practical.',
    },
    {
      title: 'Why Your Encryption Could Be Broken by a Machine That Doesn’t Exist Yet',
      publication: 'Quantum Zeitgeist',
      issue: '27 NOV 2025',
      url: 'https://quantumzeitgeist.com/why-your-encryption-could-be-broken-by-a-machine-that-doesnt-exist-yet/',
      lastAccessed: '22 DEC 2025',
      imageUrl: 'https://quantumzeitgeist.com/wp-content/uploads/cc-2.jpg',
      imageAlt: 'Abstract illustration representing quantum computing and encryption risk',
      bluf:
        'The article explains how future quantum computers could render today’s encryption obsolete using known quantum algorithms such as Shor’s and Grover’s, even though large-scale quantum machines do not yet exist.\n\nIt emphasizes the “harvest now, decrypt later” risk and the urgency of transitioning to post-quantum cryptography as quantum hardware, error correction, and scalability continue to advance.',
    }




  ];

  constructor() {
    this.sortArticlesByIssueDate();
  }

  private sortArticlesByIssueDate(): void {
    this.articles.sort((a, b) => {
      const dateA = this.parseIssueDate(a.issue);
      const dateB = this.parseIssueDate(b.issue);
      return dateB.getTime() - dateA.getTime();
    });
  }

  private parseIssueDate(issue?: string): Date {
    if (!issue) return new Date(0);
    const d = new Date(issue);
    return isNaN(d.getTime()) ? new Date(0) : d;
  }
}
